<template>
  <div class="carbon">
    <vue-particles
      :particleOpacity="0.7"
      :particlesNumber="50"
      shapeType="circle"
      :particleSize="1"
      linesColor="#00D9FF"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push">
    </vue-particles>
    <div class="section-3-container scrollable" ref="scrollContainer">
      
      <div class="container">
        <div class="curve-container" ref="curveContainer" style="position: relative;">
          <!--圆点-->
          <div class="dot_type_1 position_1"></div>
          <div class="dot_type_1 position_2"></div>
          <div class="dot_type_1 position_3"></div>
          <div class="dot_type_1 position_4"></div>
          <div class="dot_type_1 position_5"></div>
          <div class="dot_type_1 position_6"></div>
          <div class="dot_type_1 position_7"></div>
          
          <div class="circle circle_1"></div>
          <div class="circle circle_2"></div>
          <div class="circle circle_3"></div>
          <!-- <div class="circle circle_4"></div>
          <div class="circle circle_5"></div> -->

          <!-- 曲线SVG -->
          <!-- <svg class="color-curve" viewBox="0 0 985 3608" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M498.5 2.5H889.5V841H2.5V1858H982V2651.5L503 3184.5V3607.5" stroke="url(#paint0_linear_4340_492)" stroke-width="5"/>
            <defs>
              <linearGradient id="paint0_linear_4340_492" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2FFEE4"/>
                <stop offset="1" stop-color="#39CFD3"/>
              </linearGradient>
              </defs>
          </svg> -->

          <!-- <svg class="color-curve" viewBox="0 0 985 1890" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M498.5 2.5H859.5C876.069 2.5 889.5 15.9315 889.5 32.5V509.5C889.5 526.069 876.069 539.5 859.5 539.5H32.5C15.9315 539.5 2.5 552.931 2.5 569.5L2.5 1165.5C2.5 1182.07 15.9315 1195.5 32.5 1195.5H952C968.569 1195.5 982 1208.93 982 1225.5V1469.96C982 1482.83 973.785 1494.27 961.585 1498.38L523.415 1646.12C511.215 1650.23 503 1661.67 503 1674.54V1890" stroke="url(#paint0_linear_5665_1198)" stroke-width="5" stroke-dasharray="10 10"/>
            <defs>
              <linearGradient id="paint0_linear_5665_1198" gradientUnits="userSpaceOnUse">
                <stop stop-color="#44FFB0"/>
                <stop offset="1" stop-color="#33D6A9"/>
              </linearGradient>
            </defs>
          </svg> -->

          <svg class="color-curve" viewBox="0 0 985 2202" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M498.5 2.5H859.5C876.069 2.5 889.5 15.9315 889.5 32.5V509.5C889.5 526.069 876.069 539.5 859.5 539.5H32.5C15.9315 539.5 2.5 552.931 2.5 569.5L2.5 1205C2.5 1221.57 15.9315 1235 32.5 1235H952C968.569 1235 982 1248.43 982 1265V1779.31C982 1791.76 974.301 1802.93 962.656 1807.35L522.344 1974.65C510.699 1979.07 503 1990.24 503 2002.69V2202" stroke="url(#paint0_linear_5665_1198)" stroke-width="5" stroke-dasharray="10 10"/>
            <defs>
              <linearGradient id="paint0_linear_5665_1198" gradientUnits="userSpaceOnUse">
                <stop stop-color="#44FFB0"/>
                <stop offset="1" stop-color="#33D6A9"/>
              </linearGradient>
            </defs>
          </svg>


          <!-- 内容节点 - 使用transition-group包裹所有节点 -->
          <transition-group name="fade">
            <div v-show="isNodeVisible(0)" key="node-0" class="content-node content-node_1">
              <div class="content-node_1_text_1">“碳芯”大模型</div>
              <div class="content-node_1_text_2">全球首个碳中和领域垂类大模型（闭源）</div>
              <div class="content-node_1_text_3">历时4年时间潜心研发，以超过700亿条海量模型参数和8万条高精度人工语料为行业注入更多想象空间（模型开启...）</div>
              <div class="content-node_1_view" @click="gotoAgent">
                <div class="content-node_1_view_view">START TANXIN</div>
              </div>
            </div>
            
            <div v-show="isNodeVisible(1)" key="node-1" class="content-node content-node_2">
              <div class="content-node_2_text_1">2019年<br>12月26日</div>
              <div class="content-node_2_text_2">大模型首行代码</div>
            </div>
            
            <div v-show="isNodeVisible(3)" key="node-3" class="content-node content-node_2 top_1150">
              <div class="content-node_2_text_1">2024年<br>11月18日</div>
              <div class="content-node_2_text_2">获得国家网信办<br>备案批复</div>
            </div>
            
            <div v-show="isNodeVisible(4)" key="node-4" class="content-node content-node_3">
              <div class="content-node_3_text_1">LARGE LANGUAGE MODEL</div>
              <div class="content-node_3_text_2">全球首个</div>
              <div class="content-node_3_text_2">双碳领域垂直类专业大模型</div>
              <div class="content-node_3_text_3 margin_top_50">
                <div class="content-node_3_text_3_l">10000+</div>
                <div class="content-node_3_text_4">全国各省市双碳法规政策/地方条例</div>
              </div>
              <div class="content-node_3_text_3">
                <div class="content-node_3_text_3_l">80000+</div>
                <div class="content-node_3_text_4">人工撰写高精度行业QA训练数据集 </div>
              </div>
              <div class="content-node_3_text_3">
                <div class="content-node_3_text_3_l">100000+</div>
                <div class="content-node_3_text_4">24个碳排放核算工作重点行业全覆盖专业知识图谱</div>
              </div>
              <div class="content-node_3_text_3">
                <div class="content-node_3_text_3_l">150000+</div>
                <div class="content-node_3_text_4">全球主流因子库碳排因子，覆盖范围一、二、三</div>
              </div>
              <!-- <div class="content-node_3_text_4">来自于实时更新的全球各大主流因子库</div> -->
              <!-- <div class="content-node_3_text_2 margin_top_50">AI重新定义碳管理行业</div> -->
              <!-- <div class="content-node_3_text_5">多模态数据的自适应采集实现排放源数据精准捕获</div> -->
            </div>
            
            <div v-show="isNodeVisible(5)" key="node-5" class="content-node content-node_2 top_1976">
              <div class="content-node_2_text_1">2024年<br>11月25日</div>
              <div class="content-node_2_text_2">开放内测</div>
            </div>
            
            <div v-show="isNodeVisible(6)" key="node-6" class="content-node content-node_3 top_2056">
              <!-- <div class="content-node_3_text_3">提升15%</div>
              <div class="content-node_3_text_4">模型专业性实时性评分<br>相比公有云通用大模型</div> -->
              <!-- <div class="content-node_3_text_1 margin_top_30">LLM+ AI AGENT</div>
              <div class="content-node_3_text_2">大模型+AI Agent</div>
              <div class="content-node_3_text_6 margin_top_30">碳芯凭借其超过<span>700亿</span>条海量数据规模，实现了类人化的业务推理，结合首次研发的<span>双碳AI Agent工具</span>，能够精准的为用户提供从碳方案设计到碳盘查报告、碳足迹认证、ESG报告和碳交易管理全生命周期AI工具服务<br>这一极具创新颠覆性的技术与解决方案在绿色金融实践、助力企业实现零碳排放目标，以及构建零碳社区等多个应用场景中展现</div> -->
              <div class="content-node_3_text_5">知识普及与培训：</div>
              <div class="content-node_3_text_6">系统梳理双碳概念、技术路径和行业实践，提供准确知识问答与学习支持</div>
              <div class="content-node_3_text_5">政策解读与合规引导：</div>
              <div class="content-node_3_text_6">实时解析各地政策，协助理解合规要求，规避风险，把握政策红利</div>
              <div class="content-node_3_text_5">方案编写与优化：</div>
              <div class="content-node_3_text_6">支持生成碳盘查、减排规划等涉碳方案与报告，提升编写效率与专业性</div>
              <div class="content-node_3_text_5">市场预测与洞察：</div>
              <div class="content-node_3_text_6">提供行业趋势分析、碳市场价格预测、技术发展路线研判等</div>
            </div>
            
            <div v-show="isNodeVisible(2)" key="node-2" class="content-node content-node_2 top_564">
              <div class="content-node_2_text_1">2024年<br>12月12日</div>
              <div class="content-node_2_text_2">正式发布</div>
            </div>

            <div v-show="isNodeVisible(7)" key="node-7" class="content-node content-node_2 top_2400">
              <div class="content-node_2_text_1">2025年<br>11月6日</div>
              <div class="content-node_2_text_2">中碳普惠云AI服务平<br>台获得著作权</div>
            </div>
            
            <!-- <div v-show="isNodeVisible(8)" key="node-8" class="content-node content-node_5">VS</div> -->
            
            <!-- <div v-show="isNodeVisible(9)" key="node-9" class="content-node content-node_3 top_2700">
              <div class="content-node_3_text_3">提升6%</div>
              <div class="content-node_3_text_4">模型专业性实时性评分<br>相比公有云通用大模型</div>
            </div> -->
            
            <div v-show="isNodeVisible(10)" key="node-10" class="content-node content-node_3 top_2800">
              <!-- <div class="content-node_3_text_3">提升15%</div> -->
              <div class="content-node_3_text_7">面向双碳领域的专属AI<br>懂政策、会核算、善分析的行业专家</div>
            </div>
            
            <div v-show="isNodeVisible(11)" key="node-11" class="content-node content-node_2 top_3500">
              <div class="content-node_2_text_2">与"碳芯"一起<br>碳索未来</div>
            </div>
          </transition-group>
        </div>
        <Footer pageType="production" />
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/footer/index.vue'

export default {
  components: {
    Footer,
  },
  data() {
    return {
      visibleNodes: new Set(), // 存储可见节点的索引
      scrollHandler: null, // 滚动事件处理器
      nodeCount: 12 // 总节点数量
    }
  },
  mounted() {
    this.initScrollAnimation()
  },
  beforeUnmount() {
    this.removeScrollListener()
  },
  methods: {
    initScrollAnimation() {
      // 添加滚动监听
      this.scrollHandler = this.handleScroll.bind(this)
      const scrollContainer = this.$refs.scrollContainer
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', this.scrollHandler)
        // 初始检查一次
        this.handleScroll()
      }
    },
    
    removeScrollListener() {
      const scrollContainer = this.$refs.scrollContainer
      if (scrollContainer && this.scrollHandler) {
        scrollContainer.removeEventListener('scroll', this.scrollHandler)
      }
    },
    
    handleScroll() {
      const scrollContainer = this.$refs.scrollContainer
      if (!scrollContainer) return
      
      const scrollTop = scrollContainer.scrollTop
      const containerHeight = scrollContainer.clientHeight
      
      // 检查每个节点是否应该显示
      for (let i = 0; i < this.nodeCount; i++) {
        const triggerPosition = (i + 1) * 1 // 每个节点在滚动200px后触发显示
        
        if (scrollTop + containerHeight * 0.7 >= triggerPosition) {
          this.visibleNodes.add(i)
        }
      }
      
      // 触发响应式更新
      this.$forceUpdate()
    },
    
    isNodeVisible(index) {
      return this.visibleNodes.has(index)
    },

    gotoAgent(){
      window.open('https://ai.carbonneutrality-group.com/chat-app/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.carbon{
  background: linear-gradient(180deg, rgba(68, 255, 176, 0.1) 0%, rgba(51, 214, 169, 0.1) 100%);
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;

  .vue-particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;
    padding-top:325px;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .container {
      max-width: none;
      margin: 0; 
      padding: 0; 
      width: 100vw;

      .curve-container {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
        max-width: 100vw;
        height: 2202px;
        overflow: visible;

        /* 淡入动画效果 */
        .fade-enter-active {
          transition: all 0.8s ease;
        }
        
        .fade-enter-from {
          opacity: 0;
          transform: translateY(30px);
        }
        
        .fade-enter-to {
          opacity: 1;
          transform: translateY(0);
        }

        /* 为每个content-node设置不同的延迟时间，实现渐进显示效果 */
        .content-node:nth-child(1) {
          transition-delay: 0.1s;
        }
        .content-node:nth-child(2) {
          transition-delay: 0.2s;
        }
        .content-node:nth-child(3) {
          transition-delay: 0.3s;
        }
        .content-node:nth-child(4) {
          transition-delay: 0.4s;
        }
        .content-node:nth-child(5) {
          transition-delay: 0.5s;
        }
        .content-node:nth-child(6) {
          transition-delay: 0.6s;
        }
        .content-node:nth-child(7) {
          transition-delay: 0.7s;
        }
        .content-node:nth-child(8) {
          transition-delay: 0.8s;
        }
        .content-node:nth-child(9) {
          transition-delay: 0.9s;
        }
        .content-node:nth-child(10) {
          transition-delay: 1.0s;
        }
        .content-node:nth-child(11) {
          transition-delay: 1.1s;
        }
        .content-node:nth-child(12) {
          transition-delay: 1.2s;
        }

        .circle {
          position: absolute;
          background: rgba(77, 237, 180, 0.2);
          box-shadow: 0 0 400px 250px rgba(0, 237, 180, 0.2);
        }

        .circle_1 {
          top: 0;
          left: 10%;
          background: rgba(84, 252, 184, 0.15);
          box-shadow: 0 0 400px 250px rgba(0, 237, 180, 0.09);
          backdrop-filter: blur(580px);
        }

        .circle_2 {
          top: 800px;
          left: 60%;
          background: rgba(77, 237, 180, 0.2);
          box-shadow: 0 0 400px 350px rgba(77, 237, 180, 0.1);
          backdrop-filter: blur(311.29998779296875px)
        }

        .circle_3 {
          top: 1600px;
          left: 20%;
          background: rgba(73, 222, 178, 0.2);
          box-shadow: 0 0 400px 250px rgba(73, 222, 178, 0.15);
          backdrop-filter: blur(311.29998779296875px);
        }

        .circle_4 {
          top: 2800px;
          left: 25%;
        }

        .circle_5 {
          top: 3400px;
          right: 29%;
        }

        /* 圆点 */
        .dot_type_1 {
          position: absolute;
          width: 30px;
          height: 30px;
          background: #4DEDB5;
          border-radius: 50%;
          z-index: 7;
        }

        .dot_type_2 {
          position: absolute;
          width: 20px;
          height: 20px;
          background: #4DEDB5;
          border-radius: 50%;
          z-index: 7;
        }

        .position_1 {
          top: -13px;
          left: 949px;
        }

        .position_2 {
          top: 290px;
          left: 1340px;
        }

        .position_3 {
          top: 1390px;
          right: 457px;
        }

        .position_4 {
          top: 760px;
          left: 452px;
        }

        .position_5 {
          top: 986px;
          left: 452px;
        }

        .position_6 {
          top: 1675px;
          right: 457px;
        }

        .position_7 {
          top: 2078px;
          right: 937px;
        }

        /* 曲线SVG容器 */
        .color-curve {
          position: absolute;
          z-index: 6;
          top: 0;
          left: 465px;
          width: 985px;
          height: 2202px;
          overflow: visible;
        }

        .color-curve path {
          stroke-width: 5;
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 10 10;
          stroke-dashoffset: 1;
        }

        /* 内容节点 */
        .content-node {
          position: absolute;
          z-index: 5;
          display: flex;

          .content-node_icon{
            width: 108px;
            height: 15px;
          }
        }

        .content-node_1{
          width: 1044px;
          display: flex;
          flex-direction: column;
          left: 230px;
          top: -85px;

          .content-node_1_text_1{
            font-size: 88px;
            font-weight: 700;
            color: rgba(31, 100, 104, 1);
          }

          .content-node_1_text_2{
            font-size: 48px;
            font-weight: 300;
            color: rgba(45, 110, 114, 1);
          }

          .content-node_1_text_3{
            font-size: 24px;
            font-weight: 300;
            width: 750px;
            color: rgba(40, 144, 160, 1);
            line-height: 38px;
            letter-spacing: 2px;
            margin-top:20px;
          }

          .content-node_1_view{
            font-family: Inter;
            font-weight: 700;
            font-size: 20px;
            letter-spacing: 10%;
            background: linear-gradient(180deg, #FFFFFF 0%, #3F6054 50%, #1CD492 100%);
            box-shadow: 0px 10px 20px 0px #1DCF8F80;
            width: calc(100vw * 250 / 1920);
            height: calc(100vh * 65 / 1080);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50px;
            color: rgba(31, 104, 78, 1);
            margin-top:37px;
            cursor: pointer;

            .content-node_1_view_view{
              background: linear-gradient(180deg, #D1FDED 0%, #5DAA8F 100%);
              width: calc(100vw * 246 / 1920);
              height: calc(100vh * 59 / 1080);
              border-radius: 50px;
              box-shadow: 0px 10px 20px 0px #1DCF8F80;
              display: flex;
              align-items: center;
              justify-content: center;

              &:hover{
                background: linear-gradient(180deg, #D1FDED 0%, #02774D 100%);
                box-shadow: 
                  0px 10px 20px 0px rgba(29, 207, 143, 0.5),
                  0px 0px 60.3px 0px rgba(0, 54, 33, 1) inset;
                  color: #fff;
              }
            }
          }
        }

        .content-node_2{
          display: flex;
          align-items: center;
          right: 182px;
          top: 262px;
          font-weight: 200!important;
          letter-spacing: 1px;
          text-align: center;

          .content-node_2_text_1{
            font-size: 28px;
            width: 187px;
            color: rgba(45, 110, 114, 1);
            margin-right: 80px;
          }

          .content-node_2_text_2{
            font-size: 28px;
            width: 340px;
            color: rgba(40, 144, 160, 1);
            line-height: 36px;
            text-align: left;
          }
        }

        .top_564{
          top: 1361px;
          right: 150px;

          .content-node_2_text_1{
            margin-right: 0px;
          }

          .content-node_2_text_2{
            width: 318px;
            text-align: center;
          }
        }

        .top_1150{
          left: 252px;
          top: 734px;
          right: auto;

          .content-node_2_text_1{
            margin-right: 80px;
          }

          .content-node_2_text_2{
             width: 318px;
          }
        }

        .top_1976{
          top: 960px;
          left: 252px;
          right: auto;

          .content-node_2_text_1{
            margin-right: 80px;
          }

          .content-node_2_text_2{
            width: 318px;
          }
        }

        .top_2056{
          top:1360px!important;
          left:290px;
          width:734px;
        }

        .top_2400{
          top:1650px!important;
          right: 150px;
          // width:734px;

          .content-node_2_text_1{
            margin-right: 0px;
          }

          .content-node_2_text_2{
            width: 318px;
            text-align: center;
          }
        }

        .top_3500{
          top: 2055px;
          left: 960px;
          width: 282px;
          
          .content-node_2_text_2{
            text-align: center;
          }
        }

        .content-node_3{
          width: 850px;
          right: calc(100vw * 225 / 1920);
          top: 625px;
          display: flex;
          flex-direction: column;

          .content-node_3_text_1{
            font-size: 40px;
            font-weight: 300;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 5px;
            line-height:151%;
            font-family: 'Inter', sans-serif;
          }

          .content-node_3_text_2{
            font-size: 48px;
            font-weight: 700;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 2px;
            line-height:151%;
            font-family: 'Inter', sans-serif;
          }

          .content-node_3_text_3{
            font-size: 36px;
            font-weight: 600;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 2px;
            line-height:151%;
            font-family: 'Inter', sans-serif;
            display: flex;

            .content-node_3_text_3_l{
              width: 180px;
            }
          }

          .content-node_3_text_4{
            font-size: 28px;
            font-weight: 300;
            color: rgba(40, 144, 160, 1);
            letter-spacing: 2px;
            font-family: 'Inter', sans-serif;
          }

          .content-node_3_text_5{
            font-size: 32px;
            font-weight: 700;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 2px;
            line-height:180%;
            font-family: 'Inter', sans-serif;
          }

          .content-node_3_text_6{
            font-size: 24px;
            font-weight: 300;
            color: rgba(40, 144, 160, 1);
            letter-spacing: 2px;
            line-height:180%;
            font-family: 'Inter', sans-serif;

            span{
              font-weight: 700;
              font-size: 32px;
            }
          }

          .content-node_3_text_7{
            font-size: 36px;
            font-weight: 700;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 0px;
            line-height: 54px;
            text-align: center;
            font-family: 'Inter', sans-serif;
          }

          .margin_top_30{
            margin-top: 30px;
          }

          .margin_top_50{
            margin-top: 50px;
          }
        }

        .content-node_4{
          right: 195px;
          top: 2530px;
          display: flex;
          flex-direction: column;
          font-family: 'Inter', sans-serif;
          text-align: right;

          .content-node_4_text_1{
            font-size: 40px;
            font-weight: 300;
            color: rgba(45, 110, 114, 1);
            line-height: 48px;
            letter-spacing: 1px;
          }

          .content-node_4_text_2{
            font-size: 64px;
            font-weight: 700;
            color: rgba(31, 100, 104, 1);
            letter-spacing: 5px;
            line-height: 96px;
          }
        }

        .top_2700{
          top:1600px;
          left:352px;
          right: 0!important;
          text-align: left;
          width:734px;
        }

        .top_2800{
          top:1820px;
          left:470px;
          right: 0!important;
          text-align: left;
          width:590px;
        }

        .content-node_5{
          display: flex;
          align-items: center;
          justify-content: center;
          right:645px;
          top: 2843px;
          width: 156px;
          height: 156px;
          background: linear-gradient(180deg, #65E8FF 0%, #13BEE7 100%);
          color: rgba(31, 100, 104, 1);
          font-size: 96px;
          font-weight: 700;
          z-index: 6;
          border-radius: 50%;
        }

        .content-node_6{
          left:352px;
          top: 2400px;
          width: 368px;
          display: flex;
          flex-direction: column;
          font-family: Inter;
          letter-spacing: 2px;

          .content-node_6_text_1{
            font-size: 40px;
            font-weight: 700;
            line-height: 170%;
            color: rgba(31, 100, 104, 1);
          }

          .content-node_6_text_2{
            font-size: 24px;
            font-weight: 300;
            line-height: 140%;
            color: rgba(40, 144, 160, 1);
          }
        }

        .content-node_7{
          display: flex;
          left:592px;
          top: 3110px;
          width: 809px;
          flex-direction: column;

          .content-node_7_item{
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: space-between;

            .content-node_7_item_2{
              .content-node_7_img{
                width: 100px;
                height: 100px;
              }
            }

            .content-node_7_item_3{
              display: flex;
              flex-direction: column;
              width: 500px;
              color: rgba(40, 144, 160, 1);

              .content-node_7_item_3_text1{
                font-size: 28px;
                font-weight: 700;
                letter-spacing: 2px;
              }

              .content-node_7_item_3_text2{
                font-size: 24px;
                font-weight: 300;
                letter-spacing: 2px;
                line-height: 42px;
              }
            }
          }

          .margin_top_45{
            margin-top: 45px;
          }
        }

        .content-node_8{
          left: 255px;
          top: 3658px;
          width: 1200px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Inter;
          font-weight: 700;
          font-size: 64px;
          line-height: 140%;
          text-align: right;
          letter-spacing: 2px;
          color: rgba(31, 100, 104, 1);
        }

        .content-node_9{
          left: 295px;
          top: 3933px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Inter;
          font-weight: 300;
          font-size: 48px;
          color: rgba(45, 110, 114, 1);
        }

        .content-node_10{
          left: 295px;
          top: 4030px;
          display: flex;
          width: calc(100% - 590px);
          height: 480px;
          justify-content: space-between;
          align-items: center;
          z-index: 7;

          .content-node_10_l{
            width:1230px;
            height:480px;
            border-top-left-radius: 120px;
            border-bottom-right-radius: 120px;
            background: #c8f0f4;
            border: 1px solid rgba(0, 236, 206, 1);
            backdrop-filter: blur(4px);
            box-shadow: 0px -2px 1px 0px rgba(151, 193, 255, 0.4) inset;
            box-shadow: 0px 11.39px 22.34px 0px rgba(53, 106, 185, 0.09);

            .content-node_10_l_view{
              margin: 40px 43px 30px 75px;

              .content-node_10_l_view_text1{
                font-size: 24px;
                font-weight: 600;
                letter-spacing: 1px;
                line-height: 28px;
                color: rgba(45, 110, 114, 1);
              }

              .content-node_10_l_view_text2{
                font-size: 64px;
                font-weight: 600;
                letter-spacing: 1px;
                line-height: 112px;
                color: rgba(31, 100, 104, 1);
              }

              .content-node_10_l_view_text3{
                font-size: 24px;
                font-weight: 300;
                letter-spacing: 1px;
                line-height: 28px;
                color: rgba(40, 144, 160, 1);
                text-indent: 2em;
                margin-bottom: 24px;
              }

              .content-node_10_l_view_text4{
                text-align: right;
                font-size: 32px;
                font-weight: 700;
                letter-spacing: 1px;
                color: rgba(31, 100, 104, 1);
                cursor: pointer;
              }
            }
          }

          .content-node_10_r{
            width: 85px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>